import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = (segmentValue) => [
  {
    title: "Client",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "file",
    render: defaultRender,
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    render: defaultRender,
  },
  ...(segmentValue === "closed"
    ? [
        {
          title: "E-File Ack No",
          dataIndex: "acknowledge_ment_no",
          render: defaultRender,
        },
        {
          title: "E-File Ack Doc",
          dataIndex: "acknowledgement_doc",
          render: defaultRender,
        },
      ]
    : []),
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (value) => <StatusBadge status={value} />,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;
